import React from 'react';
import { payrollSystemContent } from '../rich-content/payroll-system-complete-content';
import { AutomaticPageBuilder } from '../page-sections/automatic-page-builder';

const PayrollSystemDetailPage = () => {
  return <AutomaticPageBuilder content={payrollSystemContent} />;
};

export default PayrollSystemDetailPage;
